<template>
    <div :class="imageTitle ? 'col-lg-3 col-md-6' : 'col-lg-4 col-6'" v-if="model">
        <SmartLinkItemComponent :id="model?.system?.id" :component="!model.system.workflow">
            <NuxtLink class="logo-item" :class="imageTitle ? 'image-title' : 'image-only'" :to="model.elements.link.value">
                <div class="logo">
                    <SmartLinkStandaloneElement :codename="type.elements.logo.codename">
                        <img v-if="firstOrDefault(model.elements.logo.value)" :src="model.elements.logo.value[0]!.url" :alt="model?.elements?.title?.value" class="img-fluid" />
                    </SmartLinkStandaloneElement>
                </div>
                <div class="logo-title" v-if="imageTitle">
                    <SmartLinkStandaloneElement :codename="type.elements.title.codename">
                        <h3>{{ model?.elements?.title?.value }}</h3>
                    </SmartLinkStandaloneElement>
                </div>
            </NuxtLink>
        </SmartLinkItemComponent>
    </div>
</template>

<script lang="ts" setup>
import { contentTypes, type LogoItemModel } from '~~/app/models';
const type = contentTypes.logo_item;
const props = defineProps<{ model: LogoItemModel, imageTitle:boolean }>();
</script>